"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensNameWithLensSuffix = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
/**
 * Add "Lens" suffix to lens name where required.
 */
function LensNameWithLensSuffix({ lensName }) {
    const hasLensSuffix = lensName.toLowerCase().endsWith(" lens");
    return hasLensSuffix ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: lensName })) : ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "nih7gu", description: "The name of the Lens with (Lens) appended", defaultMessage: "{lensName} Lens", values: {
            lensName: lensName,
        } }));
}
exports.LensNameWithLensSuffix = LensNameWithLensSuffix;
//# sourceMappingURL=LensNameWithLensSuffix.js.map